const init = {};
export const OwnerSettingReducer = (state = init, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
